import React from 'react';
import posthog from 'posthog-js';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/wppiUNK9xdr2ZYqDwBD61S/medmasterslogo.png';
interface NavLink {
  label: string;
  id: string;
}
const NAV_LINKS: NavLink[] = [{
  label: 'How Our System Works',
  id: 'vsl-section'
}, {
  label: 'Apply Now',
  id: 'apply'
}, {
  label: 'Proof',
  id: 'proof'
}, {
  label: 'FAQ',
  id: 'faq'
}];
export function Footer() {
  const scrollTo = (id: string) => {
    posthog.capture('footer_nav_clicked', {
      section: id
    });
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer id="footer" className="w-full scroll-mt-20 bg-ink text-white" style={{
    background: 'var(--ink)'
  }} data-id="element-62">
      <div className="max-w-[1100px] mx-auto px-6 py-16" data-id="element-63">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-64">
          {/* Left — logo + tagline */}
          <div className="flex flex-col gap-4" data-id="element-65">
            <img src={LOGO_SRC} alt="MedMasters" className="h-9 w-auto object-contain self-start max-w-[180px]" style={{
            filter: 'brightness(0) invert(1)'
          }} data-id="element-66" />
            <p className="font-sans font-normal text-[14px] leading-relaxed max-w-[280px]" style={{
            color: 'rgba(255,255,255,0.70)'
          }} data-id="element-67">
              The Patient Profit System for chiropractic owners doing
              $40K+/month.
            </p>
          </div>

          {/* Middle — Navigate */}
          <div data-id="element-68">
            <h4 className="font-sans font-semibold text-[14px] text-white mb-4" data-id="element-69">
              Navigate
            </h4>
            <ul className="flex flex-col gap-3" data-id="element-70">
              {NAV_LINKS.map(link => <li key={link.id} data-id="element-71">
                  <button type="button" onClick={() => scrollTo(link.id)} className="font-sans font-medium text-[14px] transition-colors duration-200 text-left hover:text-white" style={{
                color: 'rgba(255,255,255,0.70)'
              }} data-id="element-72">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Right — Legal */}
          <div data-id="element-73">
            <h4 className="font-sans font-semibold text-[14px] text-white mb-4" data-id="element-74">
              Legal
            </h4>
            <ul className="flex flex-col gap-3" data-id="element-75">
              <li data-id="element-76">
                <a href="#" className="font-sans font-medium text-[14px] transition-colors duration-200 hover:text-white" style={{
                color: 'rgba(255,255,255,0.70)'
              }} data-id="element-77">
                  Terms of Use
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="font-sans font-medium text-[14px] transition-colors duration-200 hover:text-white" style={{
                color: 'rgba(255,255,255,0.70)'
              }} data-id="element-79">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t text-center" style={{
        borderColor: 'rgba(255,255,255,0.1)'
      }} data-id="element-80">
          <p className="font-sans font-normal text-[12px]" style={{
          color: 'rgba(255,255,255,0.5)'
        }} data-id="element-81">
            © {new Date().getFullYear()} MedMasters. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}